import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COLLECTION_DATA} from '../../api';
import $ from "jquery";
import cogoToast from "cogo-toast";
import moment from "moment";
import {capitalize} from "../../utils/capitalize";
import 'react-quill/dist/quill.snow.css';

const Transaction = () => {

    document.title = "Transaction";

    const token = localStorage.getItem('jwtToken');

    useEffect(() => {
        let table = $('#transaction').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Transaction Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "transactions",
                        fieldname: "txn_number",
                        pageSize: data.start,
                        format: 'json',
                        populate: "user",
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];

                        res.data.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data?.user?.name ? capitalize(data.user.name) : `<span class="tx-danger">No Data</span>`;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.txn_number;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return {
                            "withdraw" : `<span class="badge badge-success tx-white">Withdraw</span>`,
                            "credit" : `<span class="badge badge-primary tx-white">Credit</span>`
                        }[data.type];
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return {
                            "paid" : `<span class="badge badge-success tx-white">Paid</span>`,
                            "failed" : `<span class="badge badge-danger tx-white">Paid</span>`,
                            "error" : `<span class="badge badge-danger tx-white">Error</span>`,
                            "pending" : `<span class="badge badge-warning tx-white">Pending</span>`,
                        }[data.status];
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY");
                    },
                    "targets": 4
                }
            ]
        });

        return () => {
            table.destroy();
        }

    }, []);

    const reloadTable = () => {
        $('#transaction').DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Transaction</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Transaction</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Transaction List</h6>
                                <div className="d-flex tx-18">
                                    <a href="#" onClick={(e) => {e.preventDefault(); $('#transaction').DataTable().ajax.reload()}} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="transaction" className="table">
                                    <thead>
                                    <tr>
                                        <th className="wd-20p">Name</th>
                                        <th className="wd-20p">TXN Number</th>
                                        <th className="wd-20p">Type</th>
                                        <th className="wd-20p">Status</th>
                                        <th className="wd-20p">Date</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Transaction;
